/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
    IonAlert,
    IonButton,
    IonItem,
    IonLabel,
    IonSelect,
    IonSelectOption,
    IonText,
    useIonLoading,
} from "@ionic/react";
import { useAuth } from "../../context/Auth";
import PageWrapper from "../layouts/PageWrapper";
import EmptyText from "../../components/EmptyText";
import {
    deleteRelation,
    fetchRelationsForBasedata,
} from "../../services/RelationServices";

import "./DatamodPage.scss";

const RelationsPage: React.FC = () => {
    const [presentLoading, dismissLoading] = useIonLoading();
    const { checkAxiosError, assigns, userInfo } = useAuth();

    const [selectedFilter, setSelectedFilter] = useState<number | null>(
        assigns !== null && assigns.length > 0 && assigns[0].length > 0
            ? assigns[0][0].base_data_id
            : null
    );
    const [users, setUsers] = useState<{
        loading: boolean;
        users: any;
    }>({
        loading: true,
        users: [],
    });
    const [showDelete, setShowDelete] = useState<number | null>(null);
    const [showAlert, setShowAlert] = useState<string | null>(null);
    const [isCurrentUserFirstRelation, setIsCurrentUserFirstRelation] =
        useState<boolean>(false);

    const setSelectedFilterWithAlert = (value: any) => {
        setSelectedFilter(value);
    };

    const deleteSystemRelation = (relation_id: number) => {
        setShowDelete(null);
        if (relation_id !== null) {
            presentLoading("Kérem várjon...");
            deleteRelation(relation_id)
                .then((res) => {
                    getRelations();
                    dismissLoading();
                    setShowAlert("Sikeres törlés!");
                })
                .catch((err) => {
                    dismissLoading();
                    checkAxiosError(err);
                });
        }
    };

    const getRelations = () => {
        if (selectedFilter) {
            presentLoading("Kérem várjon...");
            setIsCurrentUserFirstRelation(false);
            setUsers((prevState) => {
                return {
                    ...prevState,
                    loading: true,
                };
            });
            fetchRelationsForBasedata(selectedFilter)
                .then((res) => {
                    setUsers({
                        loading: false,
                        users: res.data.data.system_relations ?? [],
                    });
                    setIsCurrentUserFirstRelation(
                        res.data.data.current_user_is_first_relation ?? false
                    );
                })
                .catch((err) => {
                    checkAxiosError(err);
                    setUsers({
                        loading: false,
                        users: [],
                    });
                    setIsCurrentUserFirstRelation(false);
                })
                .finally(() => {
                    dismissLoading();
                });
        }
    };

    useEffect(() => {
        getRelations();
    }, [selectedFilter]);

    const getCode = (item: any) => {
        if (item.base_data?.related?.tax_id) {
            return item.base_data?.related?.tax_id;
        }
        return item.base_data?.related?.customer_code ?? "PK";
    };

    return (
        <PageWrapper>
            <div className="hasButton">
                <h1 className="pageTitle">Hozzárendelések</h1>
            </div>

            {assigns !== null && assigns.length > 0 ? (
                <>
                    {assigns[0].length > 0 ? (
                        <>
                            <div className="inputWithModalWrapper">
                                <p>Válasszon partnert</p>
                                <IonItem
                                    className="inputWithModal highlightedSelect"
                                    lines="none"
                                >
                                    {assigns.length > 0 ? (
                                        <IonSelect
                                            cancelText="Mégse"
                                            interface="action-sheet"
                                            className="fullLength"
                                            value={selectedFilter}
                                            placeholder="Kérem válasszon"
                                            onIonChange={(e) =>
                                                setSelectedFilterWithAlert(
                                                    e.detail.value
                                                )
                                            }
                                        >
                                            {assigns[0].map(
                                                (item: any, i: number) => (
                                                    <IonSelectOption
                                                        key={i}
                                                        value={
                                                            item.base_data_id
                                                        }
                                                    >
                                                        {`${getCode(item)} - ${
                                                            item.base_data
                                                                ?.name ?? ""
                                                        }`}
                                                    </IonSelectOption>
                                                )
                                            )}
                                        </IonSelect>
                                    ) : (
                                        <IonLabel color="secondary">
                                            Betöltés...
                                        </IonLabel>
                                    )}
                                </IonItem>
                            </div>
                        </>
                    ) : null}
                </>
            ) : null}
            <br />

            {!users.loading && (
                <>
                    {users.users.length === 0 ? (
                        <EmptyText
                            text="Nincs hozzárendelve több felhasználóhoz."
                            subtext=""
                        />
                    ) : (
                        <>
                            {users.users.map((item: any, i: number) => (
                                <div key={i}>
                                    <IonItem
                                        lines="none"
                                        button={false}
                                        detail={false}
                                    >
                                        <IonLabel>
                                            {item.user?.name ?? ""}
                                            <br />
                                            <small className="ion-margin-top">
                                                {item.user?.email ?? ""}
                                            </small>
                                            {item.is_first_relation === 1 ? (
                                                <IonText
                                                    color="warning"
                                                    style={{ display: "block" }}
                                                >
                                                    <small className="ion-margin-top">
                                                        <b>Elsődleges</b>
                                                    </small>
                                                </IonText>
                                            ) : null}
                                        </IonLabel>
                                        {userInfo.id !== item.user.id &&
                                        isCurrentUserFirstRelation ? (
                                            <IonButton
                                                fill="outline"
                                                color="danger"
                                                slot="end"
                                                onClick={() =>
                                                    setShowDelete(item.id)
                                                }
                                            >
                                                Törlés
                                            </IonButton>
                                        ) : null}
                                    </IonItem>
                                    <br />
                                </div>
                            ))}
                        </>
                    )}
                </>
            )}

            {showDelete !== null && (
                <IonAlert
                    isOpen={showDelete !== null}
                    onDidDismiss={() => setShowDelete(null)}
                    header={"Figyelem"}
                    message={"Biztosan törölni szeretné ezt a hozzárendelést?"}
                    buttons={[
                        {
                            text: "Nem",
                            role: "cancel",
                            cssClass: "secondary",
                            handler: () => {
                                setShowDelete(null);
                            },
                        },
                        {
                            text: "Igen",
                            handler: () => {
                                deleteSystemRelation(showDelete);
                            },
                        },
                    ]}
                />
            )}

            <IonAlert
                isOpen={showAlert !== null}
                onDidDismiss={() => setShowAlert(null)}
                header={"Siker"}
                message={showAlert}
                buttons={[
                    {
                        text: "Rendben",
                        role: "cancel",
                    },
                ]}
            />
        </PageWrapper>
    );
};

export default RelationsPage;
